module.exports = __webpack_public_path__ + "lib/../mitm.html";


//////////////////
// WEBPACK FOOTER
// ./lib/mitm.html
// module id = 62
// module chunks = 0